module.exports = __webpack_public_path__ + "img/cover-1.39354a07.jpg";